import { render, staticRenderFns } from "./ClassifierTab.vue?vue&type=template&id=0a71e50e&scoped=true&"
import script from "./ClassifierTab.vue?vue&type=script&lang=js&"
export * from "./ClassifierTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71e50e",
  null
  
)

export default component.exports